import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiServiceService} from '../Service/api-service.service';
import {AngularFireAuth} from '@angular/fire/auth';
import {AuthServiceService} from '../auth/auth-service.service';
import * as firebase from 'firebase';

@Component({
  selector: 'app-main-feed',
  templateUrl: './main-feed.component.html',
  styleUrls: ['./main-feed.component.css']
})
export class MainFeedComponent implements OnInit {

  resultDem: Observable<object[]>;
  resultRep: Observable<object[]>;
  resultInd: Observable<object[]>;
  logged;

  constructor(public apiServiceService: ApiServiceService,
              public authenticationService: AuthServiceService,
              private afAuth: AngularFireAuth) {
    this.isLoggedIn();
  }

  getListDemocratic(): void {
    this.apiServiceService.getListDem().subscribe(Result => this.resultDem = Result['results']);
  }

  getListRepublican(): void {
    this.apiServiceService.getListRep().subscribe(Result => this.resultRep = Result['results']);
  }

  getListIndependent(): void {
    this.apiServiceService.getListInd().subscribe(Result => this.resultInd = Result['results']);
  }
  ngOnInit() {
    this.getListDemocratic();
    this.getListRepublican();
    this.getListIndependent();
  }

  isLoggedIn() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.logged = true;
      } else {
        this.logged = false;
      }
    });
  }
}
